import cx from 'classnames';
import PropTypes from 'prop-types';

import { BrandVoiceLanguageTag } from 'src/components/BrandVoiceLanguageTag';
import { CustomTooltip } from 'src/components/CustomTooltip';
import { ToneOfVoiceCard } from 'src/components/ToneOfVoiceCard';
import { getLanguageLabel, isSameLanguage } from 'src/data/generation';
import { formatToneOfVoiceDescription } from 'src/data/toneOfVoice';

import { useStyles } from './useStyles';

export const CustomToneOfVoiceCard = ({
  className,
  toneOfVoice,
  onClick,
  selected,
  disabled,
  language,
  onEditDraft,
  onSaveDraft,
}) => {
  const styles = useStyles();

  const description = formatToneOfVoiceDescription(toneOfVoice, { language, multiline: true });
  const isDisabled =
    disabled ||
    (language &&
      toneOfVoice?.brandVoiceLanguage &&
      !isSameLanguage(toneOfVoice?.brandVoiceLanguage, language)); // do not enforce for draft tone of voice

  const getDisabledHint = (language) => {
    return `This tone of voice was not set up for\nthe ${getLanguageLabel(language)} language`;
  };

  const label = (
    <span className={styles.label}>
      <span className={styles.labelText}>{toneOfVoice.brandVoiceName}</span>
      <BrandVoiceLanguageTag
        className={styles.languageChip}
        brandVoiceLanguage={toneOfVoice?.brandVoiceLanguage}
        disabled={isDisabled}
      />
    </span>
  );

  return (
    <CustomTooltip title={isDisabled ? getDisabledHint(language) : ''}>
      <span>
        <ToneOfVoiceCard
          className={cx(styles.root, className)}
          classes={{
            description: styles.description,
          }}
          title={toneOfVoice.name}
          description={description}
          label={label}
          onClick={onClick}
          selected={selected}
          disabled={isDisabled}
          onEditDraft={onEditDraft}
          onSaveDraft={onSaveDraft}
        />
      </span>
    </CustomTooltip>
  );
};

CustomToneOfVoiceCard.propTypes = {
  className: PropTypes.string,
  toneOfVoice: PropTypes.shape({
    name: PropTypes.string,
    brandVoiceName: PropTypes.string,
    brandVoiceLanguage: PropTypes.string,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  language: PropTypes.string,
  onEditDraft: PropTypes.func,
  onSaveDraft: PropTypes.func,
};
CustomToneOfVoiceCard.defaultProps = {
  className: null,
  selected: false,
  disabled: false,
  language: null,
  onEditDraft: null,
  onSaveDraft: null,
};
